export default {
  DEFAULT: 'default',
  ADD: 'add',
  REMOVE: 'remove',
};
